import layoutHeaderAside from '@/layout/header-aside'
const meta = { auth: true }
export default {
  path: '/mediadata/',
  name: '媒资库',
  meta,
  redirect: { name: 'myfile' },
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'myfile',
      name: 'myfile',
      meta: {
        title: '我的文件',
        auth: true
      },
      component: () => import('@/views/mediadata/myfile'),
    },
    {
      path: 'myshare',
      name: 'myshare',
      meta: {
        title: '我的共享',
        auth: true
      },
      component: () => import('@/views/mediadata/myshare'),
    },
    {
      path: 'depfile',
      name: 'depfile',
      meta: {
        title: '部门文件',
        auth: true
      },
      component: () => import('@/views/mediadata/depfile'),
    },     
    {
      path: 'publicfile',
      name: 'publicfile',
      meta: {
        title: '公共文件',
        auth: true
      },
      component: () => import('@/views/mediadata/publicfile')
    },     
    {
      path: 'face',
      name: 'face',
      meta: {
        title: '人脸管理',
        auth: true
      },
      component: () => import('@/views/mediadata/face')
    }
    ])('mediadata')
}
